"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from "react";
import { Sparkles, CheckCircle2 } from "lucide-react";
import { cn } from "~/lib/utils";
import { useTranslations } from "next-intl";
export function AiSummaryDemo() {
  const $ = _c(123);
  const [step, setStep] = useState(0);
  const t = useTranslations("layout.aiDemo");
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const interval = setInterval(() => {
        setStep(_temp);
      }, 4000);
      return () => clearInterval(interval);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="h-3 w-3 rounded-full bg-red-500" />;
    t3 = <div className="h-3 w-3 rounded-full bg-yellow-500" />;
    t4 = <div className="h-3 w-3 rounded-full bg-green-500" />;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t) {
    t5 = t("title");
    $[5] = t;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <div className="border-b border-gray-100 bg-gray-50 px-4 py-3 dark:border-gray-800 dark:bg-gray-900"><div className="flex items-center gap-2">{t2}{t3}{t4}<div className="ml-4 text-xs font-medium text-gray-400">{t5}</div></div></div>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="flex h-8 w-8 items-center justify-center rounded-full bg-blue-100 text-xs font-bold text-blue-600 dark:bg-blue-900/30 dark:text-blue-400">JD</div>;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t) {
    t8 = t("message1.name");
    $[10] = t;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t8) {
    t9 = <span className="text-sm font-semibold text-gray-900 dark:text-white">{t8}</span>;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t) {
    t10 = t("message1.time");
    $[14] = t;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10) {
    t11 = <span className="text-xs text-gray-500">{t10}</span>;
    $[16] = t10;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11 || $[19] !== t9) {
    t12 = <div className="flex items-center gap-2">{t9}{t11}</div>;
    $[18] = t11;
    $[19] = t9;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t) {
    t13 = t("message1.text");
    $[21] = t;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t13) {
    t14 = <p className="rounded-lg rounded-tl-none bg-gray-100 p-3 text-sm text-gray-600 dark:bg-gray-800 dark:text-gray-300">{t13}</p>;
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t12 || $[26] !== t14) {
    t15 = <div className="flex gap-3">{t7}<div className="flex-1 space-y-1">{t12}{t14}</div></div>;
    $[25] = t12;
    $[26] = t14;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <div className="flex h-8 w-8 items-center justify-center rounded-full bg-teal-100 text-xs font-bold text-teal-600 dark:bg-teal-900/30 dark:text-teal-400">CS</div>;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t) {
    t17 = t("message2.name");
    $[29] = t;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== t17) {
    t18 = <span className="text-sm font-semibold text-gray-900 dark:text-white">{t17}</span>;
    $[31] = t17;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== t) {
    t19 = t("message2.time");
    $[33] = t;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== t19) {
    t20 = <span className="text-xs text-gray-500">{t19}</span>;
    $[35] = t19;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== t18 || $[38] !== t20) {
    t21 = <div className="flex items-center gap-2">{t18}{t20}</div>;
    $[37] = t18;
    $[38] = t20;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] !== t) {
    t22 = t("message2.text");
    $[40] = t;
    $[41] = t22;
  } else {
    t22 = $[41];
  }
  let t23;
  if ($[42] !== t22) {
    t23 = <p className="rounded-lg rounded-tl-none bg-gray-100 p-3 text-sm text-gray-600 dark:bg-gray-800 dark:text-gray-300">{t22}</p>;
    $[42] = t22;
    $[43] = t23;
  } else {
    t23 = $[43];
  }
  let t24;
  if ($[44] !== t21 || $[45] !== t23) {
    t24 = <div className="flex gap-3">{t16}<div className="flex-1 space-y-1">{t21}{t23}</div></div>;
    $[44] = t21;
    $[45] = t23;
    $[46] = t24;
  } else {
    t24 = $[46];
  }
  let t25;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <div className="flex h-8 w-8 items-center justify-center rounded-full bg-purple-100 text-xs font-bold text-purple-600 dark:bg-purple-900/30 dark:text-purple-400">S</div>;
    $[47] = t25;
  } else {
    t25 = $[47];
  }
  let t26;
  if ($[48] !== t) {
    t26 = t("message3.name");
    $[48] = t;
    $[49] = t26;
  } else {
    t26 = $[49];
  }
  let t27;
  if ($[50] !== t26) {
    t27 = <span className="text-sm font-semibold text-gray-900 dark:text-white">{t26}</span>;
    $[50] = t26;
    $[51] = t27;
  } else {
    t27 = $[51];
  }
  let t28;
  if ($[52] !== t) {
    t28 = t("message3.time");
    $[52] = t;
    $[53] = t28;
  } else {
    t28 = $[53];
  }
  let t29;
  if ($[54] !== t28) {
    t29 = <span className="text-xs text-gray-500">{t28}</span>;
    $[54] = t28;
    $[55] = t29;
  } else {
    t29 = $[55];
  }
  let t30;
  if ($[56] !== t27 || $[57] !== t29) {
    t30 = <div className="flex items-center gap-2">{t27}{t29}</div>;
    $[56] = t27;
    $[57] = t29;
    $[58] = t30;
  } else {
    t30 = $[58];
  }
  let t31;
  if ($[59] !== t) {
    t31 = t("message3.text");
    $[59] = t;
    $[60] = t31;
  } else {
    t31 = $[60];
  }
  let t32;
  if ($[61] !== t31) {
    t32 = <p className="rounded-lg rounded-tl-none bg-gray-100 p-3 text-sm text-gray-600 dark:bg-gray-800 dark:text-gray-300">{t31}</p>;
    $[61] = t31;
    $[62] = t32;
  } else {
    t32 = $[62];
  }
  let t33;
  if ($[63] !== t30 || $[64] !== t32) {
    t33 = <div className="flex gap-3">{t25}<div className="flex-1 space-y-1">{t30}{t32}</div></div>;
    $[63] = t30;
    $[64] = t32;
    $[65] = t33;
  } else {
    t33 = $[65];
  }
  const t34 = step >= 1 ? "scale-90 opacity-0" : "scale-100 opacity-100";
  let t35;
  if ($[66] !== t34) {
    t35 = cn("absolute -top-12 right-0 transition-all duration-500", t34);
    $[66] = t34;
    $[67] = t35;
  } else {
    t35 = $[67];
  }
  let t36;
  if ($[68] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = <Sparkles className="h-4 w-4" />;
    $[68] = t36;
  } else {
    t36 = $[68];
  }
  let t37;
  if ($[69] !== t) {
    t37 = t("aiButton");
    $[69] = t;
    $[70] = t37;
  } else {
    t37 = $[70];
  }
  let t38;
  if ($[71] !== t37) {
    t38 = <div className="flex transform cursor-pointer items-center gap-2 rounded-full bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-lg transition-all hover:scale-105 hover:bg-blue-700 hover:shadow-xl">{t36}{t37}</div>;
    $[71] = t37;
    $[72] = t38;
  } else {
    t38 = $[72];
  }
  const t39 = step === 0 ? "translate-y-4 opacity-0" : "translate-x-4 -translate-y-8 opacity-100";
  let t40;
  if ($[73] !== t39) {
    t40 = cn("absolute top-full left-1/2 mt-2 transform transition-all duration-1000", t39);
    $[73] = t39;
    $[74] = t40;
  } else {
    t40 = $[74];
  }
  let t41;
  if ($[75] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = <svg className="h-6 w-6 text-gray-900 drop-shadow-md" fill="currentColor" viewBox="0 0 24 24"><path d="M7 2l12 11.2-5.8.5 3.3 7.3-2.2.9-3.2-7.4-4.4 4.6V2z" /></svg>;
    $[75] = t41;
  } else {
    t41 = $[75];
  }
  let t42;
  if ($[76] !== t40) {
    t42 = <div className={t40}>{t41}</div>;
    $[76] = t40;
    $[77] = t42;
  } else {
    t42 = $[77];
  }
  let t43;
  if ($[78] !== t35 || $[79] !== t38 || $[80] !== t42) {
    t43 = <div className={t35}>{t38}{t42}</div>;
    $[78] = t35;
    $[79] = t38;
    $[80] = t42;
    $[81] = t43;
  } else {
    t43 = $[81];
  }
  const t44 = step >= 1 ? "translate-y-0 scale-100 opacity-100" : "h-0 -translate-y-4 scale-95 overflow-hidden border-0 p-0 opacity-0";
  let t45;
  if ($[82] !== t44) {
    t45 = cn("origin-top rounded-xl border border-teal-100 bg-gradient-to-br from-teal-50 to-blue-50 p-4 transition-all duration-700 ease-out dark:border-teal-900 dark:from-gray-900 dark:to-gray-900", t44);
    $[82] = t44;
    $[83] = t45;
  } else {
    t45 = $[83];
  }
  let t46;
  if ($[84] === Symbol.for("react.memo_cache_sentinel")) {
    t46 = <Sparkles className="h-4 w-4 text-teal-600" />;
    $[84] = t46;
  } else {
    t46 = $[84];
  }
  let t47;
  if ($[85] !== t) {
    t47 = t("aiSummary.title");
    $[85] = t;
    $[86] = t47;
  } else {
    t47 = $[86];
  }
  let t48;
  if ($[87] !== t47) {
    t48 = <div className="mb-2 flex items-center gap-2">{t46}<span className="text-sm font-bold text-teal-700 dark:text-teal-400">{t47}</span></div>;
    $[87] = t47;
    $[88] = t48;
  } else {
    t48 = $[88];
  }
  let t49;
  if ($[89] === Symbol.for("react.memo_cache_sentinel")) {
    t49 = <CheckCircle2 className="h-4 w-4 text-green-500" />;
    $[89] = t49;
  } else {
    t49 = $[89];
  }
  let t50;
  if ($[90] !== t) {
    t50 = t("aiSummary.point1");
    $[90] = t;
    $[91] = t50;
  } else {
    t50 = $[91];
  }
  let t51;
  if ($[92] !== t50) {
    t51 = <div className="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300">{t49}<span>{t50}</span></div>;
    $[92] = t50;
    $[93] = t51;
  } else {
    t51 = $[93];
  }
  let t52;
  if ($[94] === Symbol.for("react.memo_cache_sentinel")) {
    t52 = <CheckCircle2 className="h-4 w-4 text-green-500" />;
    $[94] = t52;
  } else {
    t52 = $[94];
  }
  let t53;
  if ($[95] !== t) {
    t53 = t("aiSummary.point2");
    $[95] = t;
    $[96] = t53;
  } else {
    t53 = $[96];
  }
  let t54;
  if ($[97] !== t53) {
    t54 = <div className="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300">{t52}<span>{t53}</span></div>;
    $[97] = t53;
    $[98] = t54;
  } else {
    t54 = $[98];
  }
  let t55;
  if ($[99] === Symbol.for("react.memo_cache_sentinel")) {
    t55 = <div className="h-2 w-2 animate-pulse rounded-full bg-orange-500" />;
    $[99] = t55;
  } else {
    t55 = $[99];
  }
  let t56;
  if ($[100] !== t) {
    t56 = t("aiSummary.action");
    $[100] = t;
    $[101] = t56;
  } else {
    t56 = $[101];
  }
  let t57;
  if ($[102] !== t56) {
    t57 = <div className="flex items-center gap-2 rounded border border-gray-100 bg-white p-2 text-sm font-medium text-gray-900 shadow-sm dark:border-gray-800 dark:bg-gray-900 dark:text-white">{t55}<span>{t56}</span></div>;
    $[102] = t56;
    $[103] = t57;
  } else {
    t57 = $[103];
  }
  let t58;
  if ($[104] !== t51 || $[105] !== t54 || $[106] !== t57) {
    t58 = <div className="space-y-2">{t51}{t54}{t57}</div>;
    $[104] = t51;
    $[105] = t54;
    $[106] = t57;
    $[107] = t58;
  } else {
    t58 = $[107];
  }
  let t59;
  if ($[108] !== t45 || $[109] !== t48 || $[110] !== t58) {
    t59 = <div className={t45}>{t48}{t58}</div>;
    $[108] = t45;
    $[109] = t48;
    $[110] = t58;
    $[111] = t59;
  } else {
    t59 = $[111];
  }
  let t60;
  if ($[112] !== t43 || $[113] !== t59) {
    t60 = <div className="relative mt-6">{t43}{t59}</div>;
    $[112] = t43;
    $[113] = t59;
    $[114] = t60;
  } else {
    t60 = $[114];
  }
  let t61;
  if ($[115] !== t15 || $[116] !== t24 || $[117] !== t33 || $[118] !== t60) {
    t61 = <div className="space-y-4 p-6">{t15}{t24}{t33}{t60}</div>;
    $[115] = t15;
    $[116] = t24;
    $[117] = t33;
    $[118] = t60;
    $[119] = t61;
  } else {
    t61 = $[119];
  }
  let t62;
  if ($[120] !== t6 || $[121] !== t61) {
    t62 = <div className="relative mx-auto max-w-2xl overflow-hidden rounded-xl border border-gray-200 bg-white shadow-2xl dark:border-gray-800 dark:bg-gray-950">{t6}{t61}</div>;
    $[120] = t6;
    $[121] = t61;
    $[122] = t62;
  } else {
    t62 = $[122];
  }
  return t62;
}
function _temp(prev) {
  return (prev + 1) % 4;
}